import { AppState } from '../../app/state/AppState';

export function selectCatalogingOnSiteEnabled(state: AppState) {
  return state.session.info.site.catalogingOnSiteEnabled !== false;
}